/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ActionComponent,
  ActionComponent$inboundSchema,
} from "./actioncomponent.js";
import { Animatic, Animatic$inboundSchema } from "./animatic.js";
import { DisplayRef, DisplayRef$inboundSchema } from "./displayref.js";
import { EBIcon, EBIcon$inboundSchema } from "./ebicon.js";

/**
 * The configuration of a summary of an equipment browser item
 */
export type SummaryConfig = {
  /**
   * The actions to display on the summary
   */
  actionComponents: Array<ActionComponent>;
  /**
   * The alias of the item that is being summarized.
   */
  alias: string;
  /**
   * Defines the configuration of an animatic. The Animatic is made up of a primitive component, and optional labels, gauges, and a shelf.
   */
  animatic: Animatic;
  /**
   * A single icon to display
   */
  deviceIcon: EBIcon;
  /**
   * The metrics to display on the summary
   */
  displayRefs: Array<DisplayRef>;
  /**
   * The kind for this summary item
   */
  kind?: string | undefined;
  /**
   * Universally unique identifier
   */
  referenceId: string;
  /**
   * The title of the summary
   */
  title: string;
};

/** @internal */
export const SummaryConfig$inboundSchema: z.ZodType<
  SummaryConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  action_components: z.array(ActionComponent$inboundSchema),
  alias: types.string(),
  animatic: Animatic$inboundSchema,
  device_icon: EBIcon$inboundSchema,
  display_refs: z.array(DisplayRef$inboundSchema),
  kind: types.optional(types.string()),
  reference_id: types.string(),
  title: types.string(),
}).transform((v) => {
  return remap$(v, {
    "action_components": "actionComponents",
    "device_icon": "deviceIcon",
    "display_refs": "displayRefs",
    "reference_id": "referenceId",
  });
});

export function summaryConfigFromJSON(
  jsonString: string,
): SafeParseResult<SummaryConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SummaryConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SummaryConfig' from JSON`,
  );
}
